// /var/www/afra/192.testproject.work/maracar8/0.8.2/myapp/src/index.js

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './redux/store';
import App from './App';
import { initLanguageOptions } from './utils/loadLanguage';

const container = document.getElementById('root');
const root = createRoot(container);

(async () => {
  // เรียกครั้งเดียวก่อน render
  await initLanguageOptions();

  root.render(
    <Provider store={store}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Provider>
  );
})();
